import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-locations',
  templateUrl: './product-locations.component.html',
  styleUrls: ['./product-locations.component.scss']
})
export class ProductLocationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
